import {defineNuxtPlugin, useCookie, useRequestEvent} from "#app";
import {useUserStore} from "~/store/user";
import type {Pinia} from "pinia";
import {FetchError} from "ofetch";

export default defineNuxtPlugin(async ({$pinia}) => {
  if (import.meta.server) {
    const userStore = useUserStore($pinia as Pinia);
    const event = useRequestEvent();
    const token = useCookie('token', {readonly: true});

    if (!token.value) {
      userStore.resetUser();
      return;
    }

    // The backend token, not a session-only UI cookie, determines whether login survives a restart.
    try {
      await userStore.fetchUser();
    } catch (error: unknown) {
      if (error instanceof FetchError && error.statusCode === 401) {
        const {clearAuthCookies} = await import('~~/server/utils/authCookies');
        if (event) clearAuthCookies(event);
        userStore.resetUser();
        return;
      }

      // Preserve credentials on network/server errors and let Nuxt show a retryable error.
      throw error;
    }
  }
})